<app-navbar></app-navbar>

<!-- ─── HERO BANNER ──────────────────────────────────────────────── -->
<section class="ach-hero">
  <div class="ach-hero-bg">
    <div class="ach-glow ach-glow-1"></div>
    <div class="ach-glow ach-glow-2"></div>
    <div class="ach-glow ach-glow-3"></div>
    <div class="ach-hero-grid"></div>
  </div>

  <div class="container position-relative" style="z-index:2;">
    <div class="ach-hero-inner">
      <!-- Left: text -->
      <div class="ach-hero-text">
        <div class="ach-hero-chip wow fadeInDown" data-wow-delay="0.1s">
          <i class="ri-medal-fill"></i>
          <span>Recognition &amp; Excellence</span>
        </div>
        <h1 class="ach-hero-title wow fadeInUp" data-wow-delay="0.2s">
          Our <span class="ach-gradient-text">Achievements</span>
        </h1>
        <p class="ach-hero-desc wow fadeInUp" data-wow-delay="0.3s">
          Celebrating milestones, honours and defining moments that mark our journey of excellence and pride.
        </p>
        <nav class="ach-breadcrumb wow fadeInUp" data-wow-delay="0.4s">
          <a routerLink="/"><i class="ri-home-4-line"></i> Home</a>
          <i class="ri-arrow-right-s-line"></i>
          <span>Achievements</span>
        </nav>
      </div>

      <!-- Right: trophy visual -->
      <div class="ach-hero-visual wow fadeInRight" data-wow-delay="0.25s">
        <div class="ach-trophy-wrap">
          <div class="ach-trophy-ring ach-tr-1"></div>
          <div class="ach-trophy-ring ach-tr-2"></div>
          <div class="ach-trophy-ring ach-tr-3"></div>
          <div class="ach-trophy-center">
            <i class="ri-trophy-fill"></i>
          </div>
          <!-- Floating badges -->
          <div class="ach-float-badge ach-fb-1"><i class="ri-medal-fill"></i> Top Rank</div>
          <div class="ach-float-badge ach-fb-2"><i class="ri-star-fill"></i> Excellence</div>
          <div class="ach-float-badge ach-fb-3"><i class="ri-award-fill"></i> Honours</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Wave bottom -->
  <div class="ach-hero-wave">
    <svg viewBox="0 0 1440 70" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0,35 C360,70 1080,0 1440,35 L1440,70 L0,70 Z" fill="#f1f5f9"/>
    </svg>
  </div>
</section>

<!-- ─── STATS STRIP ───────────────────────────────────────────────── -->
<div class="ach-stats-bar" *ngIf="News_event_data?.length">
  <div class="container">
    <div class="ach-stats-inner">
      <div class="ach-stat-item wow fadeInUp" data-wow-delay="0.1s">
        <div class="ach-stat-icon"><i class="ri-trophy-line"></i></div>
        <div>
          <span class="ach-stat-num">{{ News_event_data.length }}+</span>
          <span class="ach-stat-lbl">Achievements</span>
        </div>
      </div>
      <div class="ach-stats-sep"></div>
      <div class="ach-stat-item wow fadeInUp" data-wow-delay="0.2s">
        <div class="ach-stat-icon"><i class="ri-star-line"></i></div>
        <div>
          <span class="ach-stat-num">100%</span>
          <span class="ach-stat-lbl">Dedication</span>
        </div>
      </div>
      <div class="ach-stats-sep"></div>
      <div class="ach-stat-item wow fadeInUp" data-wow-delay="0.3s">
        <div class="ach-stat-icon"><i class="ri-award-line"></i></div>
        <div>
          <span class="ach-stat-num">Excellence</span>
          <span class="ach-stat-lbl">Our Standard</span>
        </div>
      </div>
      <div class="ach-stats-sep"></div>
      <div class="ach-stat-item wow fadeInUp" data-wow-delay="0.4s">
        <div class="ach-stat-icon"><i class="ri-shield-star-line"></i></div>
        <div>
          <span class="ach-stat-num">Pride</span>
          <span class="ach-stat-lbl">Our Legacy</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ─── CARDS GRID ────────────────────────────────────────────────── -->
<section class="ach-section">
  <div class="container">

    <!-- Section header -->
    <div class="ach-sec-header wow fadeInUp" data-wow-delay="0.1s" *ngIf="News_event_data?.length">
      <div class="ach-sec-line"></div>
      <span class="ach-sec-label"><i class="ri-medal-line"></i> All Records</span>
      <div class="ach-sec-line"></div>
    </div>

    <!-- Loading skeleton -->
    <div *ngIf="!News_event_data" class="ach-loading-wrap">
      <div class="ach-spinner"></div>
      <p>Loading achievements…</p>
    </div>

    <!-- Empty state -->
    <div *ngIf="News_event_data?.length === 0" class="ach-empty">
      <div class="ach-empty-icon"><i class="ri-medal-line"></i></div>
      <h3>No Achievements Yet</h3>
      <p>Check back soon — our records will appear here.</p>
      <a routerLink="/" class="ach-empty-btn"><i class="ri-home-4-line"></i> Back to Home</a>
    </div>

    <!-- Cards -->
    <div class="ach-grid" *ngIf="News_event_data?.length">
      <div class="ach-card wow fadeInUp"
           *ngFor="let item of News_event_data; let i = index"
           [attr.data-wow-delay]="(i % 4 * 0.08 + 0.1) + 's'"
           [routerLink]="['/achievements', item.Id]">

        <!-- Top image / gradient panel -->
        <div class="ach-card-top" [ngClass]="'ach-color-' + (i % 6)">
          <img *ngIf="item.ShowAttachments?.[0]?.FilePath"
               [src]="item.ShowAttachments[0].FilePath"
               [alt]="item.TitleEn"
               onerror="this.style.display='none'">
          <div class="ach-card-cover"></div>

          <!-- Rank badge -->
          <span class="ach-rank-badge"># {{ i + 1 }}</span>

          <!-- Medal icon (no image fallback) -->
          <div class="ach-no-img-icon" *ngIf="!item.ShowAttachments?.[0]?.FilePath">
            <i class="ri-award-fill"></i>
          </div>

          <!-- Category pill -->
          <span class="ach-cat-pill">
            <i class="ri-star-fill"></i> Achievement
          </span>
        </div>

        <!-- Card body -->
        <div class="ach-card-body">
          <h5 class="ach-card-title">{{ item.TitleEn }}</h5>
          <div class="ach-card-date">
            <i class="ri-calendar-event-line"></i>
            {{ (item.CurrentDate || item.CreatedDate) | date:'MMMM yyyy' }}
          </div>
        </div>

        <!-- Card footer -->
        <div class="ach-card-foot">
          <span class="ach-view-btn">
            View Details <i class="ri-arrow-right-line"></i>
          </span>
          <div class="ach-medal-badge">
            <i class="ri-medal-fill"></i>
          </div>
        </div>

        <!-- Hover glow border -->
        <div class="ach-card-glow"></div>
      </div>
    </div>

  </div>
</section>
